import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e9e7048a")

_pushScopeId("data-v-e9e7048a")
const _hoisted_1 = { class: "all-member-time-card-container text-gray-333 mb-20" }
const _hoisted_2 = { class: "time-card-search-narrow-down mt-6 mb-4" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-between overflow-hidden max-h-10"
}
const _hoisted_4 = {
  ref: "searchRequest",
  class: "flex flex-wrap items-center flex-1"
}
const _hoisted_5 = { class: "mr-4 font-size-14" }
const _hoisted_6 = {
  key: 0,
  class: "mr-4 mb-1 mt-1 date-chose"
}
const _hoisted_7 = { class: "text-grey-666" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, ":", -1)
const _hoisted_9 = { class: "ml-2" }
const _hoisted_10 = { class: "text-grey-666" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, ":", -1)
const _hoisted_12 = { class: "ml-2" }
const _hoisted_13 = { class: "text-grey-666" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, ":", -1)
const _hoisted_15 = { class: "ml-2" }
const _hoisted_16 = { class: "text-gray-600" }
const _hoisted_17 = {
  class: "flex items-center",
  style: {"min-width":"max-content"}
}
const _hoisted_18 = {
  key: 0,
  class: "text-gray-500 text-sm mr-8"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "font-bold font-size-18 mb-4 mt-4" }
const _hoisted_21 = { class: "flex mb-4" }
const _hoisted_22 = { class: "min-w-40 mt-3" }
const _hoisted_23 = { class: "flex mb-4" }
const _hoisted_24 = { class: "min-w-40 mt-3" }
const _hoisted_25 = { class: "w-full" }
const _hoisted_26 = { class: "flex mb-4" }
const _hoisted_27 = { class: "min-w-40 mt-3" }
const _hoisted_28 = { class: "w-full" }
const _hoisted_29 = { class: "flex mb-4" }
const _hoisted_30 = { class: "min-w-40 mt-3" }
const _hoisted_31 = { class: "w-full" }
const _hoisted_32 = { class: "flex mb-4" }
const _hoisted_33 = { class: "min-w-40 mt-3" }
const _hoisted_34 = { class: "w-full" }
const _hoisted_35 = { class: "flex mb-4" }
const _hoisted_36 = { class: "min-w-40 mt-3" }
const _hoisted_37 = { class: "w-full" }
const _hoisted_38 = { class: "flex mb-4" }
const _hoisted_39 = { class: "min-w-40 mt-3" }
const _hoisted_40 = { class: "w-full" }
const _hoisted_41 = { class: "flex mb-4" }
const _hoisted_42 = { class: "flex justify-between" }
const _hoisted_43 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-close text-2xl" }, null, -1)
const _hoisted_44 = { class: "flex" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DatePickerInput = _resolveComponent("DatePickerInput")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputSearchEmployee = _resolveComponent("InputSearchEmployee")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")
  const _component_ScrollTable = _resolveComponent("ScrollTable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (!_ctx.isExpand)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", null, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, _toDisplayString(_ctx.t('expressCondition')), 1),
                (_ctx.paramSearchTimeCard.date)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode("span", _hoisted_7, _toDisplayString(_ctx.t('period')), 1),
                      _hoisted_8,
                      _createVNode("span", _hoisted_9, _toDisplayString(_ctx.dateTimeCard), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.advancedSearchAllMemberTimeCard.unitName, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "mr-4 mb-1 mt-1 date-chose",
                    key: item
                  }, [
                    _createVNode("span", _hoisted_10, _toDisplayString(_ctx.t('unit')), 1),
                    _hoisted_11,
                    _createVNode("span", _hoisted_12, _toDisplayString(item), 1)
                  ]))
                }), 128)),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.advancedSearchAllMemberTimeCard.unitCheckinNames, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "mr-4 mb-1 mt-1 date-chose",
                    key: item
                  }, [
                    _createVNode("span", _hoisted_13, _toDisplayString(_ctx.t('attendanceOrganization')), 1),
                    _hoisted_14,
                    _createVNode("span", _hoisted_15, _toDisplayString(item), 1)
                  ]))
                }), 128)),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paramSearchTimeCard.pp_employee_ids, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "date-chose mr-4 mt-1",
                    key: item
                  }, [
                    _createVNode("span", _hoisted_16, _toDisplayString(_ctx.t('fullName')), 1),
                    _createTextVNode(" : " + _toDisplayString(_ctx.getNameEmployee(item)), 1)
                  ]))
                }), 128))
              ], 512)
            ]),
            _createVNode("div", _hoisted_17, [
              (_ctx.heightRequestSearch > 45)
                ? (_openBlock(), _createBlock("div", _hoisted_18, _toDisplayString(_ctx.t('other')), 1))
                : _createCommentVNode("", true),
              _createVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isExpand = !_ctx.isExpand)),
                class: "text-light-blue cursor-pointer hover:opacity-75 flex items-center font-size-14"
              }, [
                _createTextVNode(_toDisplayString(_ctx.t('change')) + " ", 1),
                _createVNode("span", {
                  class: ["text-2xl", _ctx.isExpand ? 'cp-icon-chevron-up' : 'cp-icon-chevron-down']
                }, null, 2)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isExpand)
        ? (_openBlock(), _createBlock("div", _hoisted_19, [
            _createVNode("div", _hoisted_20, _toDisplayString(_ctx.t('expressCondition')), 1),
            _createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, _toDisplayString(_ctx.t('period')), 1),
              _createVNode(_component_DatePickerInput, {
                class: "w-40",
                type: "month",
                format: "YYYY-MM",
                modelValue: _ctx.paramSearchTimeCard.date,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.paramSearchTimeCard.date = $event)),
                placeholder: 'YYYY-MM'
              }, null, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, _toDisplayString(_ctx.t('unit')), 1),
              _createVNode("div", _hoisted_25, [
                _createVNode(_component_MultiSelect, {
                  modelValue: _ctx.paramSearchTimeCard.unit_ids,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.paramSearchTimeCard.unit_ids = $event)),
                  options: _ctx.unitList,
                  "item-text": "unit_name",
                  "item-value": "unit_id",
                  placeholder: _ctx.t('pleaseEnterTheDepartment')
                }, null, 8, ["modelValue", "options", "placeholder"])
              ])
            ]),
            _createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, _toDisplayString(_ctx.t('attendanceOrganization')), 1),
              _createVNode("div", _hoisted_28, [
                _createVNode(_component_MultiSelect, {
                  modelValue: _ctx.paramSearchTimeCard.unit_checkin_ids,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.paramSearchTimeCard.unit_checkin_ids = $event)),
                  options: _ctx.unitList,
                  "item-text": "unit_name",
                  "item-value": "unit_id",
                  placeholder: _ctx.t('pleaseEnterTheAttendanceOrganization')
                }, null, 8, ["modelValue", "options", "placeholder"])
              ])
            ]),
            _createVNode("div", _hoisted_29, [
              _createVNode("div", _hoisted_30, _toDisplayString(_ctx.t('workingStyle')), 1),
              _createVNode("div", _hoisted_31, [
                _createVNode(_component_MultiSelect, {
                  "item-text": "working_style_name",
                  "item-value": "id",
                  options: _ctx.workingStyleMasterData,
                  modelValue: _ctx.paramSearchTimeCard.working_style_ids,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.paramSearchTimeCard.working_style_ids = $event)),
                  placeholder: _ctx.t('pleaseEnterTheWorkingStyle')
                }, null, 8, ["options", "modelValue", "placeholder"])
              ])
            ]),
            _createVNode("div", _hoisted_32, [
              _createVNode("div", _hoisted_33, _toDisplayString(_ctx.t('director')), 1),
              _createVNode("div", _hoisted_34, [
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.paramSearchTimeCard.director,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.paramSearchTimeCard.director = $event)),
                  placeholder: _ctx.t('pleaseEnterYourJobTitle')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ]),
            _createVNode("div", _hoisted_35, [
              _createVNode("div", _hoisted_36, _toDisplayString(_ctx.t('attribute')), 1),
              _createVNode("div", _hoisted_37, [
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.paramSearchTimeCard.attribute,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.paramSearchTimeCard.attribute = $event)),
                  placeholder: _ctx.t('pleaseEnterTheAttribute')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ]),
            _createVNode("div", _hoisted_38, [
              _createVNode("div", _hoisted_39, _toDisplayString(_ctx.t('fullName')), 1),
              _createVNode("div", _hoisted_40, [
                _createVNode(_component_InputSearchEmployee, {
                  placeholder: _ctx.t('pleaseEnterYourName'),
                  modelValue: _ctx.paramSearchTimeCard.pp_employee_ids,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.paramSearchTimeCard.pp_employee_ids = $event)),
                  options: _ctx.optionListEmployee,
                  reset: _ctx.resetCount
                }, null, 8, ["placeholder", "modelValue", "options", "reset"])
              ])
            ]),
            _createVNode("div", _hoisted_41, [
              _createVNode(_component_Checkbox, {
                class: "mr-8",
                label: _ctx.t('thereIsAnError'),
                value: true,
                modelValue: _ctx.paramSearchTimeCard.thereIsAnError,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.paramSearchTimeCard.thereIsAnError = $event))
              }, null, 8, ["label", "modelValue"]),
              _createVNode(_component_Checkbox, {
                label: _ctx.t('thereIsAnAlert'),
                value: false,
                modelValue: _ctx.paramSearchTimeCard.thereIsAnAlert,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.paramSearchTimeCard.thereIsAnAlert = $event))
              }, null, 8, ["label", "modelValue"])
            ]),
            _createVNode("div", _hoisted_42, [
              _createVNode(_component_Button, {
                label: _ctx.t('closeBtn'),
                variant: "outline-primary",
                onClick: _ctx.closeSearchDetail
              }, {
                default: _withId(() => [
                  _hoisted_43
                ]),
                _: 1
              }, 8, ["label", "onClick"]),
              _createVNode("div", _hoisted_44, [
                _createVNode(_component_Button, {
                  onClick: _ctx.resetParamSearch,
                  class: "mr-4",
                  variant: "outline-danger",
                  label: _ctx.t('reset')
                }, null, 8, ["onClick", "label"]),
                _createVNode(_component_Button, {
                  label: _ctx.t('narrowDown'),
                  onClick: _ctx.searchAllMemberTimeCard
                }, null, 8, ["label", "onClick"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ScrollTable, {
      headers: _ctx.headersTimeCard,
      data: _ctx.allMemberTimeCardList,
      isFixed: true,
      class: "text-center",
      "fixed-left": 2
    }, {
      "data-attribute": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.attribute)), 1)
      ]),
      "data-unsupported_application": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.unsupported_application)), 1)
      ]),
      "data-total_working_standard_hours": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.total_working_standard_hours)), 1)
      ]),
      "data-prescribed_working_time": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.prescribed_working_time)), 1)
      ]),
      "data-prescribed_outside_of_working_time": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.prescribed_outside_of_working_time)), 1)
      ]),
      "data-non_statutory_working_hours": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.non_statutory_working_hours)), 1)
      ]),
      "data-outside_special_extra_hours": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.outside_special_extra_hours)), 1)
      ]),
      "data-midnight_working_time": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.midnight_working_time)), 1)
      ]),
      "data-statutory_holiday_working_time": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.statutory_holiday_working_time)), 1)
      ]),
      "data-statutory_holiday_midnight_working_time": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(
              dataRow.statutory_holiday_midnight_working_time
            )), 1)
      ]),
      "data-break_time": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.break_time)), 1)
      ]),
      "data-paid_deemed_time": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.paid_deemed_time)), 1)
      ]),
      "data-actual_working_hours": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.actual_working_hours)), 1)
      ]),
      "data-total_working_hours": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.total_working_hours)), 1)
      ]),
      "data-total_holiday_work_days": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.total_holiday_work_days)), 1)
      ]),
      "data-total_number_of_absentee_days": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.total_number_of_absentee_days)), 1)
      ]),
      "data-total_number_of_errors": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.total_number_of_errors)), 1)
      ]),
      "data-total_number_of_holidays": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.total_number_of_holidays)), 1)
      ]),
      "data-total_number_of_substitute_holidays": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.total_number_of_substitute_holidays)), 1)
      ]),
      "data-total_number_of_taken_holidays": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.total_number_of_taken_holidays)), 1)
      ]),
      "data-total_number_of_taken_special_holiday_with_paid": _withId(({
          dataRow,
        }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(
              dataRow.total_number_of_taken_special_holiday_with_paid
            )), 1)
      ]),
      "data-total_number_of_taken_special_holiday_without_paid": _withId(({
          dataRow,
        }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(
              dataRow.total_number_of_taken_special_holiday_without_paid
            )), 1)
      ]),
      "data-total_number_of_waits": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.total_number_of_waits)), 1)
      ]),
      "data-total_weekday_commuting_days": _withId(({ dataRow }) => [
        _createVNode("div", null, _toDisplayString(_ctx.convertNumberToDateTime(dataRow.total_weekday_commuting_days)), 1)
      ]),
      "data-working_schedules": _withId(({ dataRow }) => [
        _createVNode(_component_Button, {
          class: "mx-auto",
          variant: "outline-primary",
          label: _ctx.t('attendanceRecord'),
          onClick: ($event: any) => (_ctx.goDetailAllMemberTimeCard(dataRow))
        }, null, 8, ["label", "onClick"])
      ]),
      _: 1
    }, 8, ["headers", "data"])
  ]))
})